<template>
  <div>
    <div v-if="canAddTask" @click="addTask" id="addTask" class="">
      <Btn :label="$t('tasks.addNew')" />
    </div>
    <div class="mt-2">
      <div
        class="task-container-main mb-3"
        v-for="task in sortedTasksList"
        :key="task.id"
      >
        <div :class="cssTheme" class="container-task p-2 text-size-14">
          <RenderTaskDetails
            :task="task"
            @delete="deleteTask($event, task)"
            @edit="editTask($event, task)"
            @toggle="toggleFullDescription(task)"
          />

          <!-- Start rendering  Ressources -->
          <div class="task-partisipants">
            <div
              v-if="showResourceHeadline(task)"
              class="d-flex text-weight-bold"
            >
              <div class="resource-name">{{ $t('tasks.assigned') }}</div>
              <div class="resource-comment">{{ $t('tasks.comment') }}</div>
            </div>

            <div
              v-for="resource in task.resources"
              :key="resource.id"
              class="task-participant mt-2"
            >
              <div
                v-if="task.showFullDescription || isMyJob(resource)"
                class="d-flex"
              >
                <div class="resource-name">
                  <div class="d-flex text-size-16 justify-content-between">
                    <div class="task-owner d-felx flex-grow-1 mb-1">
                      <div
                        v-if="isMyJob(resource)"
                        class="my-job d-inline border-radius text-dark-grey bg-closed p-1 resource-name"
                      >
                        {{ $t('tasks.myJob') }}
                      </div>
                      <div v-else class="d-flex align-items-center">
                        <div class="k-participant-icons">
                          <font-awesome-icon
                            v-if="1"
                            class="d-inline"
                            :icon="['fas', 'user-circle']"
                          />
                        </div>
                        <div class="k-participant-details">
                          <div class="user-name">
                            {{ resourceName(resource.participant.name) }}
                          </div>
                        </div>
                      </div>
                      <div class="task-asigned text-size-10 mt-1">
                        {{ acceptedDate(resource) }}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="task-comment text-weight-regular resource-comment"
                  v-html="resource.comment"
                ></div>
                <div
                  @click="editAssigment($event, task, resource)"
                  :class="cssEditAssigment(resource)"
                  class="resource-icon justify-content-end"
                >
                  <font-awesome-icon
                    v-if="canEditAssignment(resource)"
                    :icon="['fal', 'pencil']"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- End  rendering  Ressources -->

          <div
            v-if="canAssignParticipant(task)"
            class="task-comment text-weight-regular d-flex justify-content-start mt-2"
          >
            <Btn
              @click.native="assignJob($event, task)"
              :label="btnAssignTask"
            />
          </div>
        </div>
      </div>
    </div>
    <ModalAddTaskDialog
      ref="dlgAddTaskDialog"
      :editMode="editMode"
      :selectedTask="selectedTask"
      @ok="unselectTask"
      @cancel="unselectTask"
      :dlgStyle="dlgStyle"
    />

    <ModalAssignTaskDialog
      ref="dlgAssignTaskDialog"
      :isMyTask="isMyTask"
      :editMode="editMode"
      :selectedTask="selectedTask"
      :selectedResource="selectedResource"
      @ok="unselectTask"
      @update="updateResource"
      @unassign="unassignResource"
      @assign="assignResource"
      @cancel="unselectTask"
      :dlgStyle="dlgStyle"
    />

    <ModalConfirmDialog 
    ref="dlgConfirmDialog" 
    @ok="deleteTaskConfiremed"
    @cancel="onCancel"
    >

      {{ $t('tasks.confirmDeleteTask') }}
    </ModalConfirmDialog>





    <ModalPremiumFeatureDialog
      ref="dlgPremiumFeatureDialog"
    />
  </div>
</template>

<script>
import shared from '@/shared.js';

import { mapGetters, mapState } from 'vuex';
// import { HTTP } from '@/shared/http';

import { extend, localize } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import de from 'vee-validate/dist/locale/de.json';

import { gridMixin } from '../mixins/GridMixins';
import { renderMixin } from '../mixins/RenderMixins';

import Btn from '../~Global/Buttons/Btn.vue';
import RenderTaskDetails from '@/components/Rendering/RenderTaskDetails';
import ModalAddTaskDialog from '@/components/Rendering/ModalAddTaskDialog';
import ModalPremiumFeatureDialog from '@/components/~Global/Dialogs/ModalPremiumFeatureDialog';

import ModalAssignTaskDialog from '@/components/Rendering/ModalAssignTaskDialog';

extend('required', required);

localize('de', de);

export default {
  name: 'Tasks',
  components: {
    Btn,
    ModalAddTaskDialog,
    ModalAssignTaskDialog,
    RenderTaskDetails,
    ModalPremiumFeatureDialog,
  },
  mixins: [gridMixin, renderMixin],
  props: {
    tasksList: Array,
  },
  data() {
    return {
      isMyTask: false,
      editMode: false,
      selectedTask: null,
      //participant_id: null,
      selectedResource: null,
      showConfirmDeleteTask: false,
      currentUserParticipant: null,
    };
    // userName:null
  },

  watch: {
    participants: function () {
      this.updateCurrentParticipant();
    },
  },

  methods: {
    resourceName(name) {
      if (this.isHidden && !this.isOwner) {
        return this.$t('tasks.hiddenParticipant');
      }
      return name;
    },
    updateResource(resource) {
      console.log('onUpdate Resource:', resource);
      this.$store.dispatch('updateResource', resource);
      this.selectedResource = null;
    },

    unassignResource(resource) {
      console.log('unassignResource:', resource);
      this.$store.dispatch('unassignResource', resource);
    },

    assignResource(resource) {
      console.log('onAssign Resource:', resource);
      this.$store.dispatch('assignResource', resource);
      this.selectedResource = null;      
    },

    isMyJob(resource) {
      if (
        this.currentUserParticipant &&
        this.currentUserParticipant.id == resource.participant.id
      )
        return true;
      return false;
    },

    canAssignParticipant(task) {
      if (!task.resources) return true;
      if (task.resource_count - task.resources.length > 0) return true;
      return false;
    },

    canEditAssignment(resource) {
      if (this.isOwner) {
        return true;
      }
      if (resource.participant.user_id == null) {
        return true;
      }

      if (this.userId && resource.participant.user_id == this.userId) {
        console.log('canEditAssignment - true ', this.userId, resource);
        return true;
      }

      return false;
    },

    addTask(event) {
      const nmbFreeTasks = 10;
      const taskLimitReached = this.poll.taskCount >= nmbFreeTasks ? true : false;
      if (!this.isPremium && taskLimitReached) {
        this.$refs.dlgPremiumFeatureDialog.openModal(event);
        return;
      }
      this.editMode = false;
      this.$refs.dlgAddTaskDialog.openModal(event);
    },

    cssEditAssigment(resource) {
      if (this.canEditAssignment(resource)) {
        return 'pointer';
      }
      return null;
    },
    editAssigment(event, task, resource) {
      if (!this.canEditAssignment(resource)) return;

      if (this.isOwner) this.isMyTask = false;
      else this.isMyTask = true;
      this.selectedTask = task;
      this.editMode = true;
      this.selectedResource = resource;
      console.log('editAssigment:', task.title, this.selectedResource.participant.name);      
      this.$nextTick(() => {
        this.$refs.dlgAssignTaskDialog.openModal(event);
      });

      
    },

    assignJob(event, task) {
      console.log('assignJob');
      if (this.isOwner) this.isMyTask = false;
      else this.isMyTask = true;
      this.selectedTask = task;
      this.participant_id = null;
      this.editMode = false;
      this.$nextTick(() => {
        this.$refs.dlgAssignTaskDialog.openModal(event);
      });

    },

    toggleFullDescription(task) {
      task.showFullDescription = !task.showFullDescription;
      console.log('toggle:', task);
    },
    editTask(event, task) {
      console.log('EditTask:', event, task);
      this.editMode = true;
      this.selectedTask = task;
      this.$refs.dlgAddTaskDialog.openModal(event);
    },
    deleteTask(event, task) {
      this.selectedTask = task;
      this.editMode = false;
      this.$refs.dlgConfirmDialog.openModal(event);
    },

    deleteTaskConfiremed() {
      this.$refs.dlgConfirmDialog.closeModal();
      this.$store.dispatch('deleteTask', this.selectedTask);
      this.unselectTask();
      console.log('deleteTaskConfiremed');
    },

    onCancel() {
      this.$refs.dlgConfirmDialog.closeModal();
    },

    unselectTask() {
      this.selectedTask = null;
      console.log('unselectTask');
    },

    acceptedDate(task) {
      const locale = this.$i18n.locale;
      const options = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      };
      return new Date(task.created_at).toLocaleString(locale, options);
    },

    urlify(text) {
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      return text.replace(urlRegex, (url) => {
        let link = url;
        if (url.length > 30) {
          link = url.slice(0, 30) + '...';
        }
        return `<a href="${url}">${link}</a>`;
      });
    },

    canDelete() {
      return this.isOwner;
    },

    updateCurrentParticipant() {
      this.currentUserParticipant = this.poll.participants.find(
        (p) => p.isCurrentUser == true
      );

      console.error(
        'Task mounted: currentUserParticipant:',
        this.currentUserParticipant
      );
    },
    showResourceHeadline(task) {
      if (!task.showFullDescription) return false;
      if (task.resources && task.resources.length > 0) return true;
      return false;
    },
    assigned(task) {
      if (task.resources == null) return 0;
      return task.resources.length;
    },
    available(task) {
      return task.resource_count - this.assigned(task);
    },

    isTaskAssignedToMe(task) {
      if (task.resources == null) return false;
      for (var r of task.resources) {
        if (r.participant.user_id == this.userId) return true;
      }
      return false;
    },
  },

  computed: {
    ...mapGetters([
      'isOwner',
      'isPremium',
      'isDarkMode',
      'userId',
      'pollParticipants',
      'pollId',
      'userName',
      'currentParticipantName',
    ]),
    ...mapState({
      poll: (state) => state.poll.poll,
    }),

    sortedTasksList() {
      let sortedList = this.tasksList;
      if (this.isOwner) {
        return sortedList.sort((t1, t2) => {
          // console.log('compare tasks:', t1.title, t2.title);
          if (this.available(t1)) {
            if (this.available(t2)) {
               console.log('compare two available tasks:', t1.title, t2.title);
              let t1Created = new Date(t1.created_at);
              let t2Created = new Date(t2.created_at);
              return t1Created < t2Created;
            }
            console.log('only t1 has available slots:', t1.title, t2.title);            
            return -1;
          }
          if (this.available(t2)) {
            console.log('only t2 has available slots:', t1.title, t2.title);            
             return 1;
          }
          if (this.isTaskAssignedToMe(t1)) {
            return -1;
          }
          if (this.isTaskAssignedToMe(t2)) {
            return 1;
          }

          console.log('sort by availaiti');
          return this.available(t1) < this.available(t2);
        });
      }
      return sortedList.sort((t1, t2) => {
        if (this.isTaskAssignedToMe(t1)) return -1;
        if (this.isTaskAssignedToMe(t2)) return 1;
        return this.available(t1) < this.available(t2);
      });
    },

    canAddTask() {
      return this.isOwner;
    },

    cssTheme() {
      if (this.isDarkMode) {
        return 'dark-mode';
      }
      return 'light-mode';
    },

    btnAssignTask() {
      if (this.isOwner) return this.$t('tasks.btnAssign');
      return this.$t('tasks.btnAccept');
    },

    dlgStyle() {
      // if (this.mobileView) {
      //   return 'margin:' + this.posX + 'px auto';
      // }

      const left = this.posX - 180;
      const s = ';left:' + left + 'px; top:' + this.posY + 'px';
      console.log('Modal Dialog style:', s);
      return s;
    },
    mobileView() {
      return this.$store.state.mobileView;
    },
  },

  created() {
    this.lastUpdate = shared.lastUpdate;
    this.participantName = this.currentParticipantName;
    this.tasksList.forEach((task) => {
      this.$set(task, 'showFullDescription', false);
    });
    console.log('dlgStyle:', this.dlgStyle);
  },

  beforeMount() {},

  mounted() {
    this.updateCurrentParticipant();
  },

  beforeUpdate() {},

  updated() {
    //this.newCommentUserName = this.currentParticipantName;
  },

  beforeDestroy() {},

  destroyed() {},
};
</script>

<style scoped lang="scss">
@import '@/styles/colors';
//$bg-color: rgba(255, 255, 255, 0.3);

.comments {
  // margin-left: 5vw;
  width: 100%;
}

.container-task {
  border: 1px solid $light-grey;
  border-radius: 10px;
  width: 100%;
}

.container-task.light-mode {
  background-color: #f5f5f7;
}

.container-task.dark-mode {
  background-color: $mid-grey !important;
}

// .comments-box {
//   // margin-left: 5vw;
//   padding: 10px 20px 20px 20px;
//   border-radius: 10px;
//   background-color: $bg-color;
//   color: #1d1d1d;
//   backdrop-filter: blur(20px);
//   max-width: 800px;
// }

.task-container-main {
  display: flex;
  align-items: stretch;
  flex-direction: row;
}

.task-container-main > div {
  padding-top: 0px;
}

.task-comment {
  font-style: italic;
}

.task-owner {
  width: 150px;
}

.resource-name {
  width: 150px;
  flex-grow: 0;
}

.resource-comment {
  flex-grow: 1;
}

.resource-icon {
  width: 25px;
  flex-grow: 0;
}

.user-name {
  max-width: 150px;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
